import { render, staticRenderFns } from "./ReceiptFromInvoice.vue?vue&type=template&id=17fb85b2"
import script from "./ReceiptFromInvoice.vue?vue&type=script&lang=js"
export * from "./ReceiptFromInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports